export default "__VITE_ASSET__DJshi9lR__"